module.exports = __webpack_public_path__ + "img/UK.dbb2d233.svg";